import React from 'react'
import DowloaderForm from '../components/DowloaderForm'
import Navbar from '../components/Navbar'

function Homepage() {

    return (
        <>
            <Navbar />
            <DowloaderForm />
      
        </>
    )
}

export default Homepage